export default __webpack_public_path__ + "static/media/Book_2.0a40d2cb.png";